// extracted by mini-css-extract-plugin
module.exports = {"bodyContainer":"Body_bodyContainer__1sYf1","contentWrapper":"Body_contentWrapper__3FIqy"};